'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dGroups$002dView$0024$0024anon$002428 from "./presto.-Groups-View$$anon$28.js";
import * as $j_presto$002e$002dGroups$002dView$0024$0024anon$002430 from "./presto.-Groups-View$$anon$30.js";
import * as $j_presto$002etypes$0024$002dGroup from "./presto.types$-Group.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
import * as $j_presto$002etypes$0024$002dGroup$002dId$0024 from "./presto.types$-Group-Id$.js";
import * as $j_presto$002etypes$0024$002dGroup$002dName$0024 from "./presto.types$-Group-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupsView$$anon$27() {
  this.aYl = null;
  this.aYd = null;
  this.aYe = false;
  this.aYm = null;
  this.aYn = false;
  this.aYq = null;
  this.aYj = null;
  this.aYk = false;
  this.aYf = null;
  this.aYg = false;
  this.aYh = null;
  this.aYi = false;
  this.aYo = false;
  this.aYp = false;
  this.aYl = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aYq = "Group";
}
export { $c_Lpresto_GroupsView$$anon$27 as $c_Lpresto_GroupsView$$anon$27 };
$p = $c_Lpresto_GroupsView$$anon$27.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupsView$$anon$27;
/** @constructor */
function $h_Lpresto_GroupsView$$anon$27() {
}
export { $h_Lpresto_GroupsView$$anon$27 as $h_Lpresto_GroupsView$$anon$27 };
$h_Lpresto_GroupsView$$anon$27.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.aYl;
});
$p.M = (function() {
  if ((!this.aYe)) {
    this.aYd = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aYe = true;
  }
  return this.aYd;
});
$p.O = (function() {
  if ((!this.aYn)) {
    this.aYm = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aYn = true;
  }
  return this.aYm;
});
$p.D = (function() {
  return this.aYq;
});
$p.t = (function() {
  if ((!this.aYk)) {
    this.aYj = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("roles", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.aYk = true;
  }
  return this.aYj;
});
$p.N = (function() {
  if ((!this.aYg)) {
    this.aYf = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dId$0024.$m_Lpresto_types$GroupId$().pb(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().iQ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dName$0024.$m_Lpresto_types$GroupName$().mm(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dGroups$002dView$0024$0024anon$002428.$c_Lpresto_GroupsView$$anon$28())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.aYg = true;
  }
  return this.aYf;
});
$p.Q = (function() {
  if ((!this.aYi)) {
    this.aYh = ($j_presto$002etypes$0024$002dGroup.$m_Lpresto_types$Group$(), new $j_presto$002e$002dGroups$002dView$0024$0024anon$002430.$c_Lpresto_GroupsView$$anon$30());
    this.aYi = true;
  }
  return this.aYh;
});
$p.v = (function() {
  if ((!this.aYp)) {
    this.aYo = ($j_presto$002etypes$0024$002dGroup.$m_Lpresto_types$Group$(), false);
    this.aYp = true;
  }
  return this.aYo;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee287) => ((p) => \u03b4scrutinee287.p8(p)))($j_presto$002etypes$0024$002dGroup.$m_Lpresto_types$Group$())));
});
var $d_Lpresto_GroupsView$$anon$27 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupsView$$anon$27, "presto.GroupsView$$anon$27", ({
  JQ: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_GroupsView$$anon$27 as $d_Lpresto_GroupsView$$anon$27 };
//# sourceMappingURL=presto.-Groups-View$$anon$27.js.map
